import { createApp } from "vue";
import Awards from "./views/components/Awards.vue";
import Author from "./views/components/Author.vue";
import ArticlesPagination from "./views/components/ArticlesPagination.vue";
import Subscribe from "./views/components/Subscribe.vue";
import Charts from "./views/components/Charts.vue";
import AboutUsCarousel from "./views/components/AboutUsCarousel.vue";
import BlogTabs from "./views/components/BlogTabs.vue";
import DottedMap from "./views/components/DottedMap.vue";
import FooterSection from "./views/components/FooterSection.vue";
import CommentsArticle from "./views/components/CommentsArticle.vue";
import PostsAndServices from "./views/components/PostsAndServices.vue";
import ContactForm from "./views/components/ContactForm.vue";
import CookiesPopup from "./views/components/CookiesPopup.vue";
import CaseStudies from "./views/components/CaseStudies.vue";
import Clients from "./views/components/Clients.vue";
import WebForms from "./views/components/WebForms.vue";
import Cookies from "js-cookie";

document.addEventListener(
    "DOMContentLoaded",
    () => {
        const scrollContainer = document.getElementById("scrollContainer");
        const leftArrowButton = document.getElementById("leftArrow");
        const rightArrowButton = document.getElementById("rightArrow");
        const menuWrapper = document.getElementById("menu");
        function loadScripts() {
            setTimeout(function () {
                var leadBoosterScript = document.createElement("script");
                leadBoosterScript.src =
                    "https://leadbooster-chat.pipedrive.com/assets/loader.js";
                leadBoosterScript.defer = true;
                leadBoosterScript.nonce = "{{ csp_nonce() }}";
                document.head.appendChild(leadBoosterScript);
            }, 5000);

            setTimeout(function () {
                var webFormsScript = document.createElement("script");
                webFormsScript.src = "https://webforms.pipedrive.com/f/loader";
                webFormsScript.defer = true;
                webFormsScript.nonce = "{{ csp_nonce() }}";
                document.head.appendChild(webFormsScript);
            }, 10000);

            setTimeout(function () {
                var flowbiteScript = document.createElement("script");
                flowbiteScript.src =
                    "https://cdnjs.cloudflare.com/ajax/libs/flowbite/1.8.1/flowbite.min.js";
                flowbiteScript.async = true;
                flowbiteScript.nonce = "{{ csp_nonce() }}";
                document.head.appendChild(flowbiteScript);
            }, 500);
        }

        window.onload = loadScripts;

        function updateArrowButtons(scrollPosition, maxScroll) {
            leftArrowButton.style.display =
                scrollPosition > 0 ? "block" : "none";
            rightArrowButton.style.display =
                scrollPosition < maxScroll ? "block" : "none";
        }

        if (
            window.location.pathname === "/portfolio/ocam" ||
            window.location.pathname === "/portfolio/growmindgrow" ||
            window.location.pathname === "/portfolio/remwaste" ||
            window.location.pathname === "/portfolio/megamarket" ||
            window.location.pathname === "/portfolio/wine-cellar" ||
            window.location.pathname === "/portfolio/artoui" ||
            window.location.pathname === "/portfolio/looxis" ||
            window.location.pathname === "/portfolio/audentes" ||
            window.location.pathname === "/portfolio/music-school" ||
            window.location.pathname ===
                "/blog/staff-augmentation-vs-in-house-recruitment" ||
            window.location.pathname === "/blog/staff-augmentation-meaning" ||
            window.location.pathname ===
                "/blog/comprehensive-guide-to-hiring-mobile-app-developers" ||
            window.location.pathname ===
                "/blog/staff-augmentation-vs-outsourcing" ||
            window.location.pathname ===
                "/blog/hiring-dedicated-development-team" ||
            window.location.pathname ===
                "/blog/offshore-software-development-rates" ||
            window.location.pathname === "/blog/staff-augmentation-in-uk" ||
            window.location.pathname ===
                "/blog/how-to-find-and-hire-dedicated-web-developers" ||
            window.location.pathname === "/blog/guide-to-build-erp" ||
            window.location.pathname === "/blog/from-concept-to-impact" ||
            window.location.pathname === "/blog/custom-crm-development" ||
            window.location.pathname ===
                "/blog/how-much-does-it-cost-to-build-a-website" ||
            window.location.pathname ===
                "/blog/how-much-does-it-cost-to-design-mobile" ||
            window.location.pathname ===
                "/blog/staff-augmentation-services-in-usa" ||
            window.location.pathname ===
                "/blog/top-10-it-staff-augmentation-companies" ||
            window.location.pathname ===
                "/blog/how-to-choose-a-staff-augmentation-partner"
        ) {
            const buttonIds = [
                "dropdownDefaultButton",
                "dropdownDefaultButton2",
                "dropdownDefaultButton3",
                "dropdownDefaultButton4",
                "testimonials",
                "blog",
                "about",
                "portfolio",
            ];
            const logo1 = document.getElementById("customLogo");
            const logo2 = document.getElementById("whiteLogo");
            const logo1Mobile = document.getElementById("customLogoPhone");
            const logo2Mobile = document.getElementById("whiteLogoPhone");

            window.addEventListener(
                "scroll",
                function () {
                    const scrollPosition =
                        window.scrollY || document.documentElement.scrollTop;
                    const isAtTop = scrollPosition === 0;
                    const isPortfolioPage =
                        window.location.pathname.includes("/portfolio/");
                    const isBlogArticlePage =
                        window.location.pathname.includes("/blog/");
                    if (
                        window.scrollY > window.innerHeight &&
                        (isPortfolioPage || isBlogArticlePage)
                    ) {
                        menuWrapper.style.backgroundColor = "white";
                        logo1.style.display = "block";
                        logo2.style.display = "none";
                        logo1Mobile.style.display = "block";
                        logo2Mobile.style.display = "none";
                        buttonIds.forEach((buttonId) => {
                            const button = document.getElementById(buttonId);
                            button.style.color = "#1B1D2C";
                        });
                    } else {
                        menuWrapper.style.backgroundColor = isAtTop
                            ? "transparent"
                            : "#1B1D2C";
                        logo1.style.display = "none";
                        logo2.style.display = "block";
                        logo1Mobile.style.display = "none";
                        logo2Mobile.style.display = "block";
                        buttonIds.forEach((buttonId) => {
                            const button = document.getElementById(buttonId);
                            button.style.color = "white";
                        });
                    }
                },
                { passive: true }
            );
        }

        if (
            window.location.pathname === "/" ||
            window.location.pathname === "/industries/food-delivery" ||
            window.location.pathname === "/services/staff-augmentation"
        ) {
            const accordionButton = document.querySelector(
                "#accordion-collapse-heading-14 button"
            );
            const accordionImg = document.querySelector(".accordion-img");

            accordionButton.addEventListener("click", () => {
                accordionImg.style.display =
                    accordionImg.style.display === "none" ? "block" : "none";
            });
        }

        if (
            window.location.pathname === "/" ||
            window.location.pathname === "/about-us" ||
            window.location.pathname === "/testimonials"
        ) {
            let isScrolling = false;
            const maxScroll =
                scrollContainer.scrollWidth - scrollContainer.clientWidth;

            scrollContainer.addEventListener(
                "wheel",
                (event) => {
                    isScrolling = true;
                },
                { passive: true }
            );

            setInterval(() => {
                if (isScrolling) {
                    const scrollPosition = scrollContainer.scrollLeft;
                    updateArrowButtons(scrollPosition, maxScroll);
                    isScrolling = false;
                }
            }, 50);

            rightArrowButton.addEventListener(
                "click",
                () => {
                    const scrollPosition = scrollContainer.scrollLeft + 900;

                    scrollContainer.scrollTo({
                        left: scrollPosition,
                        behavior: "smooth",
                    });

                    updateArrowButtons(scrollPosition, maxScroll);
                },
                { passive: true }
            );

            leftArrowButton.addEventListener(
                "click",
                () => {
                    const scrollPosition = scrollContainer.scrollLeft - 900;

                    scrollContainer.scrollTo({
                        left: scrollPosition,
                        behavior: "smooth",
                    });

                    if (scrollPosition <= 0) {
                        leftArrowButton.style.display = "none";
                        rightArrowButton.style.display = "block";
                    }
                },
                { passive: true }
            );

            window.addEventListener(
                "scroll",
                function () {
                    const menuContainers = Array.from(
                        document.getElementsByClassName("offer")
                    );
                    menuContainers.forEach((menuContainer) => {
                        const options = menuContainer.querySelector(".options");
                        if (window.scrollY > 250) {
                            menuContainer.classList.add("show-offer");
                            options.classList.add("show-options");
                            menuWrapper.classList.add("shadow-md");
                        } else {
                            menuContainer.classList.remove("show-offer");
                            options.classList.remove("show-options");
                            menuWrapper.classList.remove("shadow-md");
                        }
                    });
                },
                { passive: true }
            );
        }

        if (window.location.pathname === "/testimonials") {
            const showMoreButton = document.getElementById("showMoreButton");
            const blocks = document.querySelectorAll("#blocks > div");
            let currentIndex = 4;

            showMoreButton.addEventListener("click", function () {
                for (let i = currentIndex; i < currentIndex + 2; i++) {
                    if (blocks[i]) {
                        blocks[i].style.display = "flex";
                    } else {
                        showMoreButton.style.display = "none";
                        break;
                    }
                }
                currentIndex += 2;
            });

            $(".slider-slick").slick({
                autoplay: true,
                autoplaySpeed: 0,
                speed: 5000,
                slidesToShow: 3.5,
                rows: 2,
                cssEase: "linear",
                pauseOnHover: false,
                pauseOnFocus: false,
                draggable: false,
                swipe: false,
                responsive: [
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 2.5,
                            rows: 2,
                        },
                        breakpoint: 450,
                        settings: {
                            slidesToShow: 1.5,
                        },
                    },
                ],
            });
        }

        if (
            window.location.pathname === "/portfolio/ocam" ||
            window.location.pathname === "/portfolio/growmindgrow" ||
            window.location.pathname === "/portfolio/looxis" ||
            window.location.pathname === "/portfolio/remwaste" ||
            window.location.pathname === "/portfolio/megamarket" ||
            window.location.pathname === "/portfolio/wine-cellar" ||
            window.location.pathname === "/portfolio/artoui" ||
            window.location.pathname === "/portfolio/music-school" ||
            window.location.pathname === "/portfolio/audentes"
        ) {
            const $carousel = $(".carousel");

            const flickityOptions = {
                freeScroll: true,
                wrapAround: true,
                draggable: true,
                pauseAutoPlayOnHover: false,
                autoPlay: 5000,
            };
            $carousel.flickity(flickityOptions);

            function updateClasses() {
                const flickity = $carousel.data("flickity");
                const currentCellIndex = flickity.selectedIndex;

                $carousel
                    .find(".carousel-cell")
                    .removeClass("justify-end justify-start justify-center");
                $carousel
                    .find(".carousel-cell")
                    .eq(currentCellIndex - 1)
                    .addClass("justify-end");
                $carousel
                    .find(".carousel-cell")
                    .eq(currentCellIndex)
                    .addClass("justify-center");
                $carousel
                    .find(".carousel-cell")
                    .eq(currentCellIndex + 1)
                    .addClass("justify-start");
            }

            updateClasses();

            $carousel.on("select.flickity", function () {
                updateClasses();
            });
        }
        if (window.location.pathname === "/services/staff-augmentation") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `
    {
        "@context": "http://schema.org",
        "@type": "Service",
        "serviceType": "IT Staff Augmentation Services",
        "provider": {
            "@type": "Organization",
            "name": "Giraffe Software",
            "url": "https://www.giraffesoftware.com"
        },
        "areaServed": "Worldwide",
        "offers": [{
                "@type": "Offer",
                "name": "Dedicated Development Team",
                "description": "Set up an entire dedicated team for your software product development project. Enjoy full management control while we handle everything else. Easily scale up your team as your needs grow."
            },
            {
                "@type": "Offer",
                "name": "Vendor Transition",
                "description": "Easily switch vendors with no interruptions to your processes. Our software development team can take over your project mid-journey, ensuring knowledge transfer and providing all the necessary tech support."
            },
            {
                "@type": "Offer",
                "name": "Staff Augmentation Consulting",
                "description": "Seeking professional advice on IT team extension? We can consult you on any aspects of staff augmentation and team composition, as well as screen & audit your processes."
            },
            {
                "@type": "Offer",
                "name": "Management of Distributed Teams",
                "description": "Interested in staff augmentation services, but managing a distributed team sounds too challenging? We can take that burden off your shoulders, ensuring smooth collaboration within the team."
            },
            {
                "@type": "Offer",
                "name": "Short- & Long-term IT Staff Augmentation",
                "description": "Fill the gaps in your tech team with individual professionals outstaffed from our company. Balance a fluctuating development workload by hiring our experts for the short or long term."
            },
            {
                "@type": "Offer",
                "name": "Augment Your Tech Team with Our Pre-vetted Talent",
                "description": "Augment your tech team with our pre-vetted talent! Book a call to discuss your requirements."
            }
        ]
    }
    `;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
            "@type": "Question",
            "name": "What is IT staff augmentation?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "IT staff augmentation is a team extension approach where companies collaborate with external experts provided by staffing agencies instead of hiring in-house full-time employees. Clients get full management control over outstaffed professionals who remain officially employed by a staffing provider. One of the biggest benefits is significant time and cost savings."
            }
        },
        {
            "@type": "Question",
            "name": "Is it better to search for an IT staff augmentation company in my country or overseas?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Choosing an offshore IT staff augmentation company is smart if your business is based in highly competitive markets with high standard rates for IT project roles, such as the US or Western Europe. Finding a staffing partner in regions with lower rates and excellent tech expertise, like Central and Eastern Europe, can save money without compromising on quality."
            }
        },
        {
            "@type": "Question",
            "name": "How much does staff augmentation cost?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "The cost of IT staff augmentation services depends on factors like the number of experts, their seniority levels, project duration, and the geolocation of your staffing provider. Finding a staffing agency in Central and Eastern Europe is often more cost-effective, with hourly rates much lower than in the US or Western Europe."
            }
        },
        {
            "@type": "Question",
            "name": "How many businesses use IT staff augmentation services?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "According to the Insight Success report, the IT staff augmentation market was estimated at $32.50 billion in 2021 and is anticipated to grow to $43.68 billion by 2027. Some sources state that every third company has used this team management strategy at some point."
            }
        },
        {
            "@type": "Question",
            "name": "What guarantees for your service do you provide?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "We offer a one-month probation period for all our IT staff augmentation services. During this time, you can evaluate our competencies, and if something doesn't work for you, we can stop our cooperation with no financial risks on your side."
            }
        },
        {
            "@type": "Question",
            "name": "What IT staff augmentation solutions can I choose from?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "We offer the following five types of IT staff augmentation services: Dedicated development team, Long- & short-term IT staff augmentation, Staff augmentation consulting, Management of distributed teams, Vendor transition."
            }
        }
    ]
}`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/services",
            "name": "Services"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/services/staff-augmentation",
            "name": "IT Staff Augmentation Services"
        }
    ]
}`;

            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "IT Staff Augmentation Services",
    "description": "With our IT staff augmentation company, you can expand your in-house tech team with seasoned developers quickly and affordably.",
    "brand": {
        "@type": "Brand",
        "name": "Giraffe Software"
    },
    "review": [{
        "@type": "Review",
        "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "ratingCount": "14",
            "reviewCount": "14",
            "bestRating": "5"
        },
        "author": {
            "@type": "Organization",
            "name": "Clutch",
            "url": "https://clutch.co/profile/giraffe-software"
        }
    }]
}`;

            document.head.appendChild(script);
            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }
        if (window.location.pathname === "/services/web-development") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "Service",
            "serviceType": "Custom Web App Development Services",
            "provider": {
                "@type": "Organization",
                "name": "Giraffe Software",
                "url": "https://www.giraffesoftware.com"
            },
            "areaServed": "Worldwide",
            "offers": [{
                    "@type": "Offer",
                    "name": "Backend Development Services",
                    "description": "Our services cover server-side programming, including cloud-based application development. We build advanced web architectures and deliver stable code, guaranteeing the product's scalability and security."
                },
                {
                    "@type": "Offer",
                    "name": "Custom Web Design Services",
                    "description": "With our UX & UI design and consulting services, you'll get visually stunning and intuitive interfaces with everything needed to engage visitors and create a memorable impression."
                },
                {
                    "@type": "Offer",
                    "name": "Frontend Development Services",
                    "description": "Hire our frontend developers to get a mobile-first solution with a dynamic interface. Our experts use cutting-edge frameworks, ensuring your web product aligns with the latest industry trends."
                },
                {
                    "@type": "Offer",
                    "name": "Progressive Web Apps & Single-Page Apps Development",
                    "description": "We create SEO-friendly responsive SPAs that load at lightning speed. We also develop PWAs that seamlessly merge the best of web and mobile, delivering delightful experiences across all devices."
                },
                {
                    "@type": "Offer",
                    "name": "QA Services & Software Testing Services",
                    "description": "We ensure flawless performance and reliability of the web solutions we build through our quality assurance and testing services. This includes regular testing, as well as regression and integration tests."
                },
                {
                    "@type": "Offer",
                    "name": "Web Solution Support & Maintenance Services",
                    "description": "Our custom web app development services extend beyond the release. We can provide continuous support for your solution, handling technical issues, troubleshooting, backup & recovery, and necessary updates."
                }
            ]
        }
    `;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "Why should I choose Giraffe Software as my custom web app development partner?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "At Giraffe Software, we offer a superb price/quality ratio, years of experience, a 100% positive review score, and a 5/5 average referral rating on Clutch. Our team provides exceptional expertise at moderate rates, covering services like progressive web apps (PWAs) development, single-page apps (SPAs) development, technology consultation, website redesign, and modernization."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does it take to complete the custom web app development project?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The development time varies, but typically starts at around 4 months. Our proactive approach, well-established processes, and collaborative teams allow us to cut 30% off the time to finish a custom web app development project."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What's the cost of custom web development services?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost depends on specialists' seniority, project complexity, and development approach. Delegating tasks to a reputable Central and Eastern European company like Giraffe Software can provide the same expertise at significantly lower hourly rates than US or Western European developers."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What technology would I need for a custom web app development project?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "There is no cookie-cutter template for custom web application development. Giraffe Software works with both time-tested and the latest technologies, including PHP, Node.js, React.js, and Vue.js. The technology stack is determined based on project requirements after discussing the idea with clients."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How do you ensure custom web app development security?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Giraffe Software ensures security through quality assurance testing, thorough code reviews, regular security patches, data backups, and adherence to the General Data Protection Regulation (GDPR) for handling personal and sensitive information with care, transparency, and security."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What does it take to give our existing website an overhaul?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "For a website overhaul, Giraffe Software follows the same process used for full-cycle web app development. This includes interviewing the client to determine requirements, creating specifications, splitting the to-do list into smaller iterations, testing and reviewing the code, and assisting with web solution deployment and maintenance."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/services",
                    "name": "Services"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/services/web-development",
                    "name": "Custom Web Development Services"
                }
            ]
        }`;

            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": "Custom Web Development Services",
            "description": "Leverage our web development services to create a top-notch website or web app designed to meet your unique needs and business goals.",
            "brand": {
                "@type": "Brand",
                "name": "Giraffe Software"
            },
            "review": [{
                "@type": "Review",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "ratingCount": "14",
                    "reviewCount": "14",
                    "bestRating": "5"
                },
                "author": {
                    "@type": "Organization",
                    "name": "Clutch",
                    "url": "https://clutch.co/profile/giraffe-software"
                }
            }]
        }`;

            document.head.appendChild(script);
            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }

        if (window.location.pathname === "/about-us") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "AboutPage",
            "mainEntityOfPage": {
                "@type": "WebPage",
                "@id": "https://giraffesoftware.com/about-us"
            },
            "about": {
                "@type": "Organization",
                "name": "Giraffe Software",
                "description": "Giraffe Software is a top provider of staff augmentation and software development
                services.Learn more about our company 's history, team, values, and expertise.",
                "foundingDate": "2016-01-01",
                "founders": [{
                        "@type": "Person",
                        "name": "Dmytro Navozenko"
                    },
                    {
                        "@type": "Person",
                        "name": "Eugene Prystupa"
                    }
                ],
                "address": [{
                        "@type": "PostalAddress",
                        "streetAddress": "Mechnikova str. 19, office 705",
                        "addressLocality": "Dnipro",
                        "addressCountry": "Ukraine"
                    },
                    {
                        "@type": "PostalAddress",
                        "streetAddress": "Harju maakond, Kesklinna linnaosa, Kaupmehe tn 7-120",
                        "addressLocality": "Tallinn",
                        "addressCountry": "Estonia"
                    }
                ],
                "contactPoint": {
                    "@type": "ContactPoint",
                    "email": "info@giraffesoftware.com",
                    "contactType": "customer service"
                }
            }
        }
    `;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `  {
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "What is an IT outsourcing & outstaffing company?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "It's a software development company that builds custom solutions from scratch based on client requests and also provides skilled tech professionals to businesses as a staffing agency. A company like that can cover UI/UX design services, tech consulting, legacy software modernization services, and more. In general, IT outsourcing & outstaffing companies help businesses meet their goals by giving them quick access to the required tech talent and resources."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Why can I trust Giraffe Software?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "We have over 7 years of hands-on experience in custom software application development. Our team has successfully completed 120+ projects, serving more than 60 satisfied clients globally. Our continuous commitment to excellence and professional development is reflected in our 5/5 referral rating on Clutch and GoodFirms, along with a 100% job success rate on Upwork. Please feel free to check out our portfolio, which showcases our track record of delivering top-quality results and our client testimonials."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What services do you provide?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Giraffe Software is a full-cycle web and mobile app development agency that provides a wide range of IT services, including staff augmentation and dedicated development teams, custom software development services, web development services (incl. progressive web app & single-page app development), mobile development services (iOS, Android, and cross-platform/hybrid), and UI/UX design services."
                    }
                },
                {
                    "@type": "Question",
                    "name": "When should I opt for staff augmentation services?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "It is best to consider staff augmentation services when you need to scale up your custom software application development capabilities and do it fast. This will allow you to easily hire experts with specialized skills on a short- or long-term basis when you need to complete a project quickly. Once the project is over, you can scale the team down without the challenges associated with in-house employment. In general, staff augmentation is an ideal solution to address skill gaps, manage workload fluctuations, and meet project deadlines efficiently."
                    }
                },
                {
                    "@type": "Question",
                    "name": "When should I outsource software development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Outsourcing custom software application development is a good idea when you need to access specialized tech expertise, balance your in-house team's workload, deal with complex product requirements, or accelerate project timelines. Partnering with a software development company particularly benefits projects with tight budgets and timeframes. You can cut a large share of development costs by choosing a team located in a region with comparatively low rates for the same level of expertise, like Central and Eastern Europe. Local developers there charge 2-4 times less than their colleagues in the US and Western Europe. On top of that, outsourcing is also a smart move when you need to focus on core business activities while trusting your development partner to handle the technical aspects."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What does the Giraffe Software's cooperation process look like?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cooperation process at our software development company depends on the services you request. If you need staff augmentation, we will take the following steps: 1. Discuss your requirements 2. Find experts who fit these requirements and send their CVs to you 3. Sign an NDA and arrange technical interviews 4. Let you choose the best candidate 5. Send an offer to the selected candidate and do onboarding. If you need custom software application development, the steps will be these: 1. Discuss your idea and put together high-level technical requirements 2. Create UI/UX design and a prototype and detail the requirements 3. Develop the product in two-week sprints 4. Test the product by running manual and automation tests 5. Deploy the product and provide post-release support and maintenance if needed."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://giraffesoftware.com/"
            }, {
                "@type": "ListItem",
                "position": 2,
                "name": "Web and Mobile Development Company",
                "item": "https://giraffesoftware.com/about-us"
            }]
        }`;

            document.head.appendChild(script);
            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/about-us") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "ContactPage",
            "about": [{
                    "@type": "ContactPoint",
                    "contactType": "customer service",
                    "areaServed": "Worldwide",
                    "email": "info@giraffesoftware.com"
                },
                {
                    "@type": "ContactPoint",
                    "contactType": "sales",
                    "areaServed": "Worldwide",
                    "email": "sales@giraffesoftware.com"
                },
                {
                    "@type": "ContactPoint",
                    "contactType": "hr",
                    "areaServed": "Worldwide",
                    "email": "hr@giraffesoftware.com"
                }
            ]
        }
    `;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/contact-us",
                    "name": "Software Development & IT Outstaffing | Contact Us"
                }
            ]
        }`;
            document.head.appendChild(script);
            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/contact-us") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "ContactPage",
            "about": [{
                    "@type": "ContactPoint",
                    "contactType": "customer service",
                    "areaServed": "Worldwide",
                    "email": "info@giraffesoftware.com"
                },
                {
                    "@type": "ContactPoint",
                    "contactType": "sales",
                    "areaServed": "Worldwide",
                    "email": "sales@giraffesoftware.com"
                },
                {
                    "@type": "ContactPoint",
                    "contactType": "hr",
                    "areaServed": "Worldwide",
                    "email": "hr@giraffesoftware.com"
                }
            ]
        }
    `;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/contact-us",
                    "name": "Software Development & IT Outstaffing | Contact Us"
                }
            ]
        }`;
            document.head.appendChild(script);
            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/portfolio",
                    "name": "Case Studies | Custom Software Development"
                }
            ]
        }`;
            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/privacy-policy") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/privacy-policy",
                    "name": "Privacy Policy"
                }
            ]
        }`;
            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/terms-and-conditions") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `       {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/terms-and-conditions",
                    "name": "Terms and Conditions"
                }
            ]
        }`;
            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/testimonials") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/testimonials",
                    "name": "Testimonials"
                }
            ]
        }`;
            document.head.appendChild(scriptList);
        }
        if (
            window.location.pathname === "/services/custom-software-development"
        ) {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "Service",
            "serviceType": "Custom Software Development Services",
            "provider": {
                "@type": "Organization",
                "name": "Giraffe Software",
                "url": "https://www.giraffesoftware.com"
            },
            "areaServed": "Worldwide",
            "offers": [{
                    "@type": "Offer",
                    "name": "Legacy Software Modernization",
                    "description": "Hire our custom software developers to revamp your outdated applications. We’ll use the latest technologies, modern architectural approaches, and best security practices to ensure your software remains relevant and efficient."
                },
                {
                    "@type": "Offer",
                    "name": "API Development",
                    "description": "Our team provides API development services to create a bridge between your software and third-party solutions, enabling them to integrate and share data seamlessly."
                },
                {
                    "@type": "Offer",
                    "name": "Third-Party Integration",
                    "description": "As part of our third-party API integration services, we can connect your software to external applications, enhancing its functionality and ensuring a smooth data flow throughout your IT ecosystem."
                },
                {
                    "@type": "Offer",
                    "name": "Software Product Customization",
                    "description": "Already have a software solution but need it to fit your requirements? With our software product customization services, we can adjust any product to perfectly match your business needs."
                },
                {
                    "@type": "Offer",
                    "name": "End-to-End Software Development",
                    "description": "We transform ideas into fully functional software solutions, covering all stages of custom app development — from ideation to deployment to post-release support."
                },
                {
                    "@type": "Offer",
                    "name": "Software Support & Maintenance",
                    "description": "Our team can take care of your software even after its release. We'll handle updates, regular troubleshooting, bug fixes, and optimization as part of our software maintenance and support services."
                }
            ]
        }
    `;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "What is custom software development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Unlike off-the-shelf solutions offering the same functionality for all users, custom applications are built based on specific client requirements. Custom software development services usually include market research, UI/UX design, coding, deployment, and maintenance. They can also involve SaaS development, legacy system modernization, product customization, as well as API development & integration."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does it take to complete a custom software product development project?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Custom software product development can take from a few weeks to several months. The timeline depends on the project scope and complexity, the required third-party API integrations, team expertise, development methodology, and many other aspects. However, a perfectly synchronized team and well-honed processes help us save our clients up to 30% of the development time."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What is the cost of custom software product development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Custom software development costs depend on various factors, including the project's scope, timeline, developers' seniority, and team location. You need to share your product vision and requirements with your software development vendor to get a detailed estimate. One of the most effective ways to make the process more budget-friendly is to outsource it to a reputable custom software development company in Central and Eastern Europe."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What are the advantages of having Giraffe Software as a custom app development partner?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "With Giraffe Software, you can cut your IT budget by up to 50% since our rates are much lower than those charged by developers in many other regions, including the US or Western Europe. Moreover, when you hire our custom software developers, you can speed up your product's launch by 30% thanks to our well-established and proven processes. We also take pride in our outstanding expertise, with around 80% of our developers being middle and senior specialists, and we have a solid track record of successfully completed projects. Our team is always ready to go beyond expectations to ensure client satisfaction."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How should I choose a custom software development company?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "When selecting a custom software development company, consider factors like their experience, expertise in relevant technologies and industries, successful project history, testimonials, and communication skills. Also, make sure they provide the services you need. It's also good to ask if the company follows an agile methodology (like Scrum or Kanban) to ensure an efficient development process. Finally, check out the company's reviews on Clutch, GoodFirms, or Upwork."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What cooperation model is better for custom software product development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "It depends on the project's complexity and your budget. The fixed-price model is more appropriate for short-term, predictable projects with well-defined requirements. The Time & Material (T&M) model lets you negotiate an hourly rate, which is ideal for complex custom software product development projects with vague scope. Giraffe Software also offers a hybrid model with a capped minimal and maximum price, which is the best fit for startups and offline businesses looking to embrace digitalization."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/services",
                    "name": "Services"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/services/custom-software-development",
                    "name": "Custom Software Development Services"
                }
            ]
        }`;

            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": "Custom Software Development Services",
            "description": "Outperform your competitors with innovative solutions built by our custom software development company. Check out our product development services!",
            "brand": {
                "@type": "Brand",
                "name": "Giraffe Software"
            },
            "review": [{
                "@type": "Review",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "ratingCount": "14",
                    "reviewCount": "14",
                    "bestRating": "5"
                },
                "author": {
                    "@type": "Organization",
                    "name": "Clutch",
                    "url": "https://clutch.co/profile/giraffe-software"
                }
            }]
        }`;

            document.head.appendChild(script);
            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }

        if (window.location.pathname === "/services/mobile-app-development") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "Service",
            "serviceType": "Custom Mobile App Development Services",
            "provider": {
                "@type": "Organization",
                "name": "Giraffe Software",
                "url": "https://www.giraffesoftware.com"
            },
            "areaServed": "Worldwide",
            "offers": [{
                    "@type": "Offer",
                    "name": "Custom iOS App Development Services",
                    "description": "Hire our iOS app developers to build cutting-edge solutions for Apple devices. Our team keeps up-to-date with the latest Apple technologies and design principles to deliver mobile apps that truly stand out."
                },
                {
                    "@type": "Offer",
                    "name": "Custom Android App Development Services",
                    "description": "Our seasoned developers can build a mobile app that performs flawlessly on various Android devices. We'll support you at every development stage — from consulting and prototyping to Android app testing and deployment."
                },
                {
                    "@type": "Offer",
                    "name": "Cross-platform & Hybrid App Development Services",
                    "description": "With our cross-platform and hybrid mobile app development services, you can reach millions of mobile users without burning your budget. And no worries — we'll ensure your app meets high users' expectations with a native-like look and feel."
                },
                {
                    "@type": "Offer",
                    "name": "Mobile App Design Services",
                    "description": "Our UX/UI experts design attractive, easy-to-navigate interfaces that guarantee delightful interactions with your mobile app, keeping users engaged from the first touch."
                },
                {
                    "@type": "Offer",
                    "name": "Mobile App Testing Services",
                    "description": "As a part of our mobile application testing services, we regularly test mobile solutions across devices and scenarios to check if they perform optimally and deliver a top-notch experience. Our QA experts also run regression and integration tests."
                },
                {
                    "@type": "Offer",
                    "name": "Mobile App Support & Maintenance Services",
                    "description": "Beyond development, we provide ongoing support and maintenance to mobile apps, keeping them efficient, secure, and up-to-date. Our team can cover bug-fixing, troubleshooting, crafting new features, mobile app modernization, and more."
                }
            ]
        }
    `;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "What are the advantages of outsourcing custom mobile app development to Giraffe Software?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Choosing Giraffe means working with a custom mobile app development company that leverages the experience of seasoned tech experts who have built dozens of stellar mobile solutions. Our 5/5 rating on reputable review platforms, such as Clutch and GoodFirms, speaks for itself. You also benefit from well-established processes when you hire our Android app developers and iOS or cross-platform/hybrid programmers for your mobile project. We'll guide you throughout the mobile development journey, from ideation to hybrid/Android/iOS app testing, helping you sidestep major pitfalls. Our expertise, paired with a well-synced team, allows us to reduce the development time by up to 30%."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does it take to complete native or cross-platform mobile app development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The time it takes to complete a mobile app development project varies as it depends on numerous factors, including the app's functionality, non-functional requirements, project management methodology, and team expertise. At Giraffe Software, we speed up the process with ready-to-go processes and a well-coordinated team. We slash 30% off the usual time to complete native or cross-platform/hybrid mobile app development. More specifically, it usually takes around 4 to 9 months for one developer to create a mobile app for one platform (iOS or Android). If you need a cross-platform app based on React Native or Flutter, the development time will be shorter, ranging from 3 to 6 months. In this case, you'll get a mobile solution that works on both platforms — Android and iOS."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does it cost to hire a custom mobile app development company?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost of hiring a custom mobile app development company depends on many aspects, such as your project scope and your vendor's geographical location. For example, when you hire mobile app developers from Central and Eastern Europe, you can save up to 50% of your budget since their hourly rates are 2-4 times lower than those charged by programmers in many local markets (e.g., the US, Western Europe). At Giraffe Software, we first discuss your project with you and then develop a rough estimate of the overall budget. On average, cross-platform mobile app development based on React Native or Flutter costs from $5,000 to $25,000. Native mobile app development comes at a higher price, ranging from $15,000 to $35,000 for each platform (Android and iOS)."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Which is the best option: native, cross-platform, or hybrid mobile app?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "It all depends on your budget and business needs. Native apps are made specifically for iOS or Android, making them highly responsive but more expensive. On the other hand, hybrid apps are more affordable to create but may not be as responsive as native ones. Cross-platform apps involve writing code once and deploying it on multiple platforms, resulting in a cost-efficient process that doesn't compromise user experience. As an experienced custom mobile app development company, we can consult you on the best option to suit your needs."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What are custom mobile app development services?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Custom mobile app development refers to building mobile solutions tailored to your needs. It can cover Custom iOS app development services, Custom Android app development services, and Hybrid/cross-platform mobile app development services. On top of this, custom mobile app development services often involve thorough consulting and prototyping to ensure the result meets your requirements."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What types of solutions can we build using your mobile app development services?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "You can develop any mobile solution with our custom mobile app development company. Examples include eLearning apps for remote education with gamification components, eCommerce apps for convenient online shopping, selling, and marketing, Retail apps that help match landlords with tenants, and Food delivery apps for ordering food in a few clicks."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/services",
                    "name": "Services"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/services/mobile-app-development",
                    "name": "Custom Mobile App Development Company"
                }
            ]
        }`;

            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": "Custom Mobile App Development Company",
            "description": "Leverage our mobile app development services to build a stunning mobile app that will propel your business growth. We guarantee fast development and moderate rates.",
            "brand": {
                "@type": "Brand",
                "name": "Giraffe Software"
            },
            "review": [{
                "@type": "Review",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "ratingCount": "14",
                    "reviewCount": "14",
                    "bestRating": "5"
                },
                "author": {
                    "@type": "Organization",
                    "name": "Clutch",
                    "url": "https://clutch.co/profile/giraffe-software"
                }
            }]
        }`;

            document.head.appendChild(script);
            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }
        if (window.location.pathname === "/services/ui-ux-design") {
            var script = document.createElement("script");

            script.type = "application/ld+json";

            script.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "Service",
            "serviceType": "UX & UI Design and Consulting Services",
            "provider": {
                "@type": "Organization",
                "name": "Giraffe Software",
                "url": "https://www.giraffesoftware.com"
            },
            "areaServed": "Worldwide",
            "offers": [{
                    "@type": "Offer",
                    "name": "User Research Services",
                    "description": "Opt for our user research services to better grasp your audience's needs, challenges, and behaviors. Get more data-driven designs without wasting time and money developing the wrong features."
                },
                {
                    "@type": "Offer",
                    "name": "User Journey Mapping Services",
                    "description": "We can create user journey maps visualizing every step of your product's user experience. You can refine your future product with all bottlenecks uncovered for better engagement and satisfaction."
                },
                {
                    "@type": "Offer",
                    "name": "Wireframing Services",
                    "description": "Visualize your product's idea with our wireframing services. We'll create clear and structured layouts displaying basic functionality and providing a foundation for further development."
                },
                {
                    "@type": "Offer",
                    "name": "Prototyping Services",
                    "description": "Get a prototype to validate your concept, establish a shared product vision among all stakeholders, and persuade potential investors. As a part of our prototyping services, we can create a minimum lovable product."
                },
                {
                    "@type": "Offer",
                    "name": "UX Consultancy Services",
                    "description": "We can help you improve your product's user experience by analyzing your goals and audience's needs. Our experts will offer insights and recommendations to make your product stand out."
                },
                {
                    "@type": "Offer",
                    "name": "Information Architecture Services",
                    "description": "Our designers can build subtle information architecture to ensure logical and enjoyable interactions with your product. We'll create a holistic and intuitive flow that smoothly guides users to their goals."
                }
            ]
        }
    `;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "What are the advantages of outsourcing UI/UX design services to Giraffe Software?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Outsourcing UI/UX design services to Giraffe Software offers you a number of advantages. Having successfully completed 120+ projects for 60+ clients during 7+ years, we have garnered a solid reputation for our quality work, confirmed by a 5/5 rating on Clutch and GoodFirms. We will be happy to become your all-in-one design partner. Our company offers a wide range of services, including UX consulting, wireframing & prototyping, UX audit, usability testing, full-cycle branding, and more."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What are the important factors to consider when creating a product design?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "When creating a product design, several key aspects should be considered. First and foremost is understanding users' needs and pain points. That's because a user-centered design means aligning your product with the target audience's expectations. To achieve this, you'll need to do an in-depth user research. Also, it's crucial to do user testing since it often uncovers friction. These elements or actions hinder users from achieving their goals, leading to difficulties and frustration. Simplifying and streamlining the user journey is a key foundation of a delightful experience. Other aspects depend on the type of design you need (i.e., web design or mobile app design). If you hire our web designers or mobile app designers, they'll guide you through the process."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How can UI/UX design services improve my product?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "UI/UX design services can greatly enhance user satisfaction, one of the defining factors for any product's success. More specifically, UX/UI design services can optimize the product's layouts, navigation, and interactions. This, in turn, will improve the usability of your product, creating seamless and engaging experiences. As a result, more users will want to use your product, which will then translate into a larger user base and business growth."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does creating a UX/UI design for a web and mobile app take?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The timeline for creating a web design and mobile app design depends on many factors, including the product's type and complexity, features, and the team's expertise. Generally, simple products take 2 weeks (80 hours) and 6 months (1,000 hours) for more sophisticated solutions. A typical design process involves several stages: research, wireframing & prototyping, concept & style development, and the design of final interfaces. If you hire our mobile app designers or web designers, they will provide you with a more detailed estimate based on your specific requirements."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does it cost to hire a company providing UI/UX design services?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost of hiring a company for UI/UX design services can vary based on project scope, complexity, and the provider's location. To save your budget, consider hiring designers from Central and Eastern Europe. Their hourly rates are usually 2-4 times lower than those in the US and Western Europe, which allows you to cut your budget by up to 50%. This cost-effective option does not compromise quality and expertise, though. So, it becomes an attractive choice for businesses looking to maximize value while maintaining top-notch design quality."
                    }
                },
                {
                    "@type": "Question",
                    "name": "I already have a website/mobile app. Can you redesign it?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Sure! Our UI/UX design services include redesigning websites and mobile apps to enhance their look and user experience. Whether you want to modernize your design, improve its usability, or align it with your evolving visual identity, we've got you covered. Our team can also do user research and user journey mapping and build information architecture before the redesign to ensure the changes positively impact how your product is perceived."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = ` {
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/services",
                    "name": "Services"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/services/ui-ux-design",
                    "name": "UI/UX Design Services"
                }
            ]
        }`;

            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
            "@context": "http://schema.org/",
            "@type": "Product",
            "name": "UI/UX Design Services",
            "description": "Choose our UI/UX design services to get high-end interfaces with an appealing look and delightful user experience that will take your product to the top of the market.",
            "brand": {
                "@type": "Brand",
                "name": "Giraffe Software"
            },
            "review": [{
                "@type": "Review",
                "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "ratingCount": "14",
                    "reviewCount": "14",
                    "bestRating": "5"
                },
                "author": {
                    "@type": "Organization",
                    "name": "Clutch",
                    "url": "https://clutch.co/profile/giraffe-software"
                }
            }]
        }`;

            document.head.appendChild(script);
            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }

        if (
            window.location.pathname ===
            "/industries/ecommerce-and-online-stores"
        ) {
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = ` {
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "Why is it better to outsource custom eCommerce website development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Outsourcing eCommerce development can save time and costs for small retailers. It leverages the expertise of experienced developers, resulting in a quicker time-to-market and lower investments."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Why is custom retail software development better than using zero-code solutions?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Custom retail software development offers long-term benefits with full control over the software. It allows precise tailoring to business needs, compatibility with other software, scalability, and enhanced security for customer data."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What is the best platform for zero-code eCommerce software development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Market leaders for basic eCommerce development with little coding include Shopify, Magento, and WooCommerce. However, custom retail software development provides a unique branded shopping experience, distinguishing businesses from competitors."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does eCommerce software development take?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The duration depends on project requirements, deadline, tech stack, team size, and budget. Basic online stores can be set up in a couple of weeks, while complex eCommerce solutions may take months, considering subsequent maintenance and support."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How do you ensure that shopper information is protected?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "We prioritize security by building eCommerce solutions according to GDPR standards. Rigorous testing, including sprint tests, regression tests, and integration tests, is conducted. Continuous post-release cybersecurity enhancements and regular data backups are part of our approach."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can you integrate a new eCommerce solution into my existing one?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Absolutely! After eCommerce software development, we can integrate your solution with any service you choose. This includes integrations with payment processing, shipping, loyalty program management, and more. Various methods, including APIs, webhooks, and SDKs, are used for connections."
                    }
                }
            ]
        }`;

            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "eCommerce Software Development Services",
    "description": "Looking for an eCommerce software development company? Reach out to us and maximize your sales potential with a powerful custom software solution.",
    "brand": {
        "@type": "Brand",
        "name": "Giraffe Software"
    },
    "review": [{
        "@type": "Review",
        "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "ratingCount": "14",
            "reviewCount": "14",
            "bestRating": "5"
        },
        "author": {
            "@type": "Organization",
            "name": "Clutch",
            "url": "https://clutch.co/profile/giraffe-software"
        }
    }]
}`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/industries",
                    "name": "Industries"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/industries/ecommerce-and-online-stores",
                    "name": "eCommerce Software Development Services"
                }
            ]
        }`;

            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptProduct);
            document.head.appendChild(scriptList);
        }

        if (window.location.pathname === "/industries/elearning") {
            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "eLearning Software Development Company",
    "description": "Looking for an eCommerce software development company? Reach out to us and maximize your sales potential with a powerful custom software solution.",
    "brand": {
        "@type": "Brand",
        "name": "Giraffe Software"
    },
    "review": [{
        "@type": "Review",
        "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "ratingCount": "14",
            "reviewCount": "14",
            "bestRating": "5"
        },
        "author": {
            "@type": "Organization",
            "name": "Clutch",
            "url": "https://clutch.co/profile/giraffe-software"
        }
    }]
}`;

            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "How long does eLearning software development take?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The timeframe for eLearning software development varies based on project specifics. It can range from a few months to a year or more, depending on factors such as project scope, complexity, required expertise, and other considerations. For an accurate time estimate, share your project requirements with us."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Why should I commission your services for my eLearning software development project?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Choosing our services means partnering with an experienced eLearning software development company. We excel in building successful products, from engaging game-based language-learning apps to robust school management systems. Our client-oriented approach, commitment to satisfaction (reflected in our 5/5 referral rating on Clutch), and positive reviews showcase our dedication. Explore our portfolio for featured eLearning software development projects completed by our team."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can your eLearning software development company create a custom eLearning solution?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Absolutely! We have the expertise to handle a wide range of eLearning software development projects. Whether you need a tailor-made school administrative software, a gamified employee engagement app, a virtual classroom platform, or any other solution, we can build it from the ground up."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does eLearning software development cost?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost of eLearning software development is influenced by factors like complexity, feature set, design, and chosen platform. Custom learning management system development may cost more than a simple skill-boosting app. Additionally, the team's geographic location matters, with developers in regions like Central and Eastern Europe offering top-notch expertise at lower rates."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How to hire a developer for an eLearning platform development project?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Hiring a developer for an eLearning project involves a careful selection process. Check if the developer provides eLearning app development services. Review their portfolio, testimonials, and client feedback to assess their expertise and reputation in elearning software development. Look for featured case studies related to eLearning projects."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What kind of eLearning software can you develop?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "We can develop a wide range of eLearning solutions, including learning management systems, school administrative software, corporate learning portals, induction and orientation apps, employee engagement apps, on-demand eLearning apps, language-learning apps, and EdTech platforms with online courses and tutoring apps. Share your idea with us, and we'll explore how to make it a reality."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/industries",
                    "name": "Industries"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/industries/elearning",
                    "name": "eLearning Software Development Company"
                }
            ]
        }`;

            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }
        if (window.location.pathname === "/industries/erp-and-crm") {
            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "ERP and CRM Development",
    "description": "Unlock business potential with our expert ERP and CRM application development services. We offer exceptional expertise, advanced security, and reasonable rates.",
    "brand": {
        "@type": "Brand",
        "name": "Giraffe Software"
    },
    "review": [{
        "@type": "Review",
        "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "ratingCount": "14",
            "reviewCount": "14",
            "bestRating": "5"
        },
        "author": {
            "@type": "Organization",
            "name": "Clutch",
            "url": "https://clutch.co/profile/giraffe-software"
        }
    }]
}`;
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "Can you modernize the legacy ERP & CRM systems?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Absolutely! As part of our CRM & ERP maintenance and upgrade services, we can revitalize your existing business process automation software. Our team can enhance your CRM or ERP functionality and ensure the solution aligns with your current needs, technological advancements, and security requirements. We'll walk you through the entire process, from assessment and planning to data migration and quality assurance."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What's the cost of custom ERP software development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost of custom ERP software development can vary significantly based on several factors, including the complexity of the system and the number of modules required. If you need only a few basic modules (e.g., document management, project management, and financial management), the cost will naturally be lower than when 8-10 modules are requested. The more extensive and complex the ERP system, the higher the development cost. That said, you can significantly reduce your ERP software development budget by choosing developers from Central and Eastern Europe."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does custom CRM software development cost?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The cost of custom CRM software development depends on various factors, and it's often best to consult with your tech partner for a precise estimate. But to give you a rough idea, our custom CRM development company considers the following aspects when calculating the budget for projects of this kind: team size and seniority level, deadlines, project scope, functionality, tech stack, and required integrations."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What is an ERP system? What is CRM software?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "ERP stands for Enterprise Resource Planning. This comprehensive software solution integrates and manages core business processes, including document management, service operations management, human resources management (HRM), and financial management. CRM stands for Customer Relationship Management. This powerful business process automation software helps organizations build better customer relationships by efficiently managing all interactions, tracking sales leads, and improving customer feedback management."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What ERP and CRM development services does Giraffe Software offer?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Giraffe Software offers a comprehensive suite of ERP and CRM development services, including Custom CRM development services, Custom ERP software development, CRM & ERP integration, CRM & ERP maintenance and upgrades, ERP consulting. Additionally, they provide business automation software development services such as HRM software development, Inventory management system development, Manufacturing software development, and other business process automation software as needed."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What does CRM & ERP software do?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "CRM and ERP software are powerful tools that help businesses streamline operations, manage customer relationships, and optimize resource utilization. CRM software focuses on customer interactions, sales, and marketing, while ERP software handles broader business processes like finance management, human resources management, and service operations management. Together, they enhance efficiency, data sharing, and decision-making across an organization."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/industries",
                    "name": "Industries"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/industries/erp-and-crm",
                    "name": "ERP and CRM Development"
                }
            ]
        }`;

            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }
        if (window.location.pathname === "/industries/food-delivery") {
            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "Food Delivery App Development Company",
    "description": "Looking for food & restaurant software development services to take your food business to new heights? We are here to bring your idea to life quickly and cost-effectively.",
    "brand": {
        "@type": "Brand",
        "name": "Giraffe Software"
    },
    "review": [{
        "@type": "Review",
        "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "ratingCount": "14",
            "reviewCount": "14",
            "bestRating": "5"
        },
        "author": {
            "@type": "Organization",
            "name": "Clutch",
            "url": "https://clutch.co/profile/giraffe-software"
        }
    }]
}`;
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "What technologies do you use for restaurant and grocery delivery app development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "If you need a restaurant app development company that uses top-notch technologies to build modern products with the potential for rapid growth — look no further. These are just a few examples. For cross-platform restaurant mobile apps, we use React Native and Flutter. For web solutions, JavaScript frameworks, Apache, and Laravel work best. We also use MySQL and Redis for databases and Amazon AWS for hosting."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How much does it cost to build an on-demand food delivery app?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Be it the development of a customer-facing delivery app, delivery person app, or both, the cost depends on factors like the app's complexity, tech stack, developers’ location and professional level, and development approach. Contact us for more details about the cost of our food restaurant software development services. We'll provide a detailed quote based on the preferred design and specifications."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What are some basic and advanced functions of a modern restaurant mobile app?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "A basic on-demand food delivery app allows users to sign up and log in, browse food venues — from fine-dining restaurants to food trucks, review menus, place orders, select delivery options, pay for and track orders, and get push notifications. Advanced features typically include scheduled ordering, voice search, food allergy alerts, AR for menu and dish visualizations, AI-powered predictive ordering, and beyond."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How can I monetize my on-demand food delivery app?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "There's a wide variety of monetization strategies. You can charge customers for delivery service, get a commission fee per each order from restaurants, offer subscription plans, display ads from restaurants and post promotional listings, enable in-app purchases of virtual items, etc. Our restaurant and grocery delivery app development company can help you implement any of these revenue streams."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How will your food ordering app development company ensure that my app is secure?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Whether it's a restaurant slot reservation or grocery mobile app development, we never take shortcuts with security. As part of our food delivery app development services, we implement robust security protocols (GDPR and beyond), 2FA, and secure APIs. All our solutions undergo a series of sprint, regression, and integration tests. Finally, we monitor and improve the security posture of your product post-release."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What are the typical payment gateway options for food delivery app development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "You can certainly implement a custom payment processing feature. However, integrating your on-demand food delivery app with third-party payment gateways remains a go-to option. Solutions like Stripe, PayPal, Google Pay, Apple Pay, and the like provide a secure payment flow. The choice of a specific gateway will depend on your requirements for geographic coverage, pricing, ease of use, and data privacy."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/industries",
                    "name": "Industries"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/industries/food-delivery",
                    "name": "Food Delivery App Development Company"
                }
            ]
        }`;

            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }
        if (
            window.location.pathname === "/industries/real-estate-and-proptech"
        ) {
            var scriptProduct = document.createElement("script");
            scriptProduct.type = "application/ld+json";
            scriptProduct.innerHTML = `{
    "@context": "http://schema.org/",
    "@type": "Product",
    "name": "Real Estate Software Development Company",
    "description": "Looking to empower your real estate business with tech? Capitalize on the property market with our custom real estate software development services.",
    "brand": {
        "@type": "Brand",
        "name": "Giraffe Software"
    },
    "review": [{
        "@type": "Review",
        "reviewRating": {
            "@type": "Rating",
            "ratingValue": "5",
            "ratingCount": "14",
            "reviewCount": "14",
            "bestRating": "5"
        },
        "author": {
            "@type": "Organization",
            "name": "Clutch",
            "url": "https://clutch.co/profile/giraffe-software"
        }
    }]
}`;
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
                    "@type": "Question",
                    "name": "What is the cost of custom real estate software development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The real estate software development cost ranges from $20,000 to $200,000 and beyond, depending on project requirements. But with our flexible cooperation options — staff augmentation and full-time dedicated teams— you aren't going to pay extra for proptech software development and other projects. We also offer three contract types: fixed price, time and material, and a hybrid hourly-based model with a fixed price range."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How long does real estate software development take?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "The duration of real estate software development varies depending on platform type, feature scope, design consideration, integration needs, and beyond. On average, it takes anywhere from 2 to 6 months or longer. However, uncertainty does not sit well with Giraffe Software. Once you approve the prototype, we’ll give you a precise deadline estimation, ensuring timely product delivery — be it a simple listing platform or a complex brokerage management system."
                    }
                },
                {
                    "@type": "Question",
                    "name": "What types of real estate software can you develop?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "As a real estate software development company, we can build a solution of any type and complexity. But basically, our expertise boils down to solutions for commercial and non-commercial property management to keep a pulse on all processes in one or multiple properties; CRM to handle tenant data and lead generation; ERP to allocate budget, human resources, and assets wisely; valuation and investment to invest only in profitable assets and price them strategically; and rental marketplaces."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Why should I choose Giraffe Software for real estate software development?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "As a real estate app development company, we have a spotless reputation — the result of our commitment to delivering value (not just code), niche experience, and expertise in technologies needed to build a stellar app for real estate agents and tenants. We are committed to efficiency and deliver projects strictly within budget and 30% faster than average software development companies. Finally, we can adjust the end product perfectly to your needs, thanks to Scrum."
                    }
                },
                {
                    "@type": "Question",
                    "name": "How do you ensure that the UX and UI of my real estate software solutions tick all the boxes?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Whether it's listing platform or real estate website development, we follow four principles regarding UX and UI. First, we analyze your audience and your specific business needs. Second, we stick to the best UX/UI design practices, such as visual appeal and consistency, responsiveness, mobile friendliness, and beyond. Third, the prototype is only implemented with your approval. Fourth, we refine the design post-release based on user feedback."
                    }
                },
                {
                    "@type": "Question",
                    "name": "Can you migrate my data to the new software?",
                    "acceptedAnswer": {
                        "@type": "Answer",
                        "text": "Certainly, our services go beyond real estate software development. The intricacy of data transfer shouldn't drive you away from tapping into all opportunities with a new tool. We'll help you switch from legacy software to a new tool with little to no downtime. Regardless of the data volume, data structure complexity, and format, we guarantee record integrity — whether it's property management software (PMS) or a rental marketplace."
                    }
                }
            ]
        }`;
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/industries",
                    "name": "Industries"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/industries/real-estate-and-proptech",
                    "name": "Real Estate Software Development Company"
                }
            ]
        }`;

            document.head.appendChild(scriptFAQ);
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptProduct);
        }
        if (window.location.pathname === "/portfolio/artoui") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "item": "https://giraffesoftware.com/",
                "name": "Home"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "item": "https://giraffesoftware.com/portfolio",
                "name": "Portfolio"
            },
            {
                "@type": "ListItem",
                "position": 3,
                "item": "https://giraffesoftware.com/portfolio/artoui",
                "name": "Artoui"
            }
        ]
    }`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/audentes") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "item": "https://giraffesoftware.com/",
                "name": "Home"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "item": "https://giraffesoftware.com/portfolio",
                "name": "Portfolio"
            },
            {
                "@type": "ListItem",
                "position": 3,
                "item": "https://giraffesoftware.com/portfolio/audentes",
                "name": "Audentes"
            }
        ]
    }`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/growmindgrow") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
                "@type": "ListItem",
                "position": 1,
                "item": "https://giraffesoftware.com/",
                "name": "Home"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "item": "https://giraffesoftware.com/portfolio",
                "name": "Portfolio"
            },
            {
                "@type": "ListItem",
                "position": 3,
                "item": "https://giraffesoftware.com/portfolio/growmindgrow",
                "name": "GrowMindGrow"
            }
        ]
    }`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/looxis") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/portfolio",
            "name": "Portfolio"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/portfolio/looxis",
            "name": "Looxis"
        }
    ]
}`;

            document.head.appendChild(scriptList);
        }

        if (window.location.pathname === "/portfolio/megamarket") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/portfolio",
            "name": "Portfolio"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/portfolio/megamarket",
            "name": "Megamarket"
        }
    ]
}`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/music-school") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/portfolio",
            "name": "Portfolio"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/portfolio/music-school",
            "name": "Music school"
        }
    ]
}`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/ocam") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/portfolio",
            "name": "Portfolio"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/portfolio/ocam",
            "name": "Ocam"
        }
    ]
}`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/remwaste") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/portfolio",
            "name": "Portfolio"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/portfolio/remwaste",
            "name": "Remwaste"
        }
    ]
}`;

            document.head.appendChild(scriptList);
        }
        if (window.location.pathname === "/portfolio/wine-cellar") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
    "@context": "http://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [{
            "@type": "ListItem",
            "position": 1,
            "item": "https://giraffesoftware.com/",
            "name": "Home"
        },
        {
            "@type": "ListItem",
            "position": 2,
            "item": "https://giraffesoftware.com/portfolio",
            "name": "Portfolio"
        },
        {
            "@type": "ListItem",
            "position": 3,
            "item": "https://giraffesoftware.com/portfolio/wine-cellar",
            "name": "Wine Cellar"
        }
    ]
}`;

            document.head.appendChild(scriptList);
        }
        if (
            window.location.pathname ===
            "/blog/staff-augmentation-vs-in-house-recruitment"
        ) {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/blog",
                    "name": "Blog"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/blog/staff-augmentation-vs-in-house-recruitment",
                    "name": "IT Staff Augmentation vs. In-House Recruitment: Costs, Processes, and Benefits"
                }
            ]
        }`;
            var scriptArticle = document.createElement("script");
            scriptArticle.type = "application/ld+json";
            scriptArticle.innerHTML = `    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "IT Staff Augmentation vs. In-House Recruitment: Costs, Processes, and Benefits",
      "image": "https://giraffesoftware.com/images/blog-article.jpg",
      "datePublished": "2024-08-12T15:00:00+02:00",
      "dateModified": "2024-08-12T15:00:00+02:00",
      "author": [{
          "@type": "Person",
          "name": "Prystupa Eugene",
          "url": "https://giraffesoftware.com/author"
        }]
    }`;
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
            "@type": "Question",
            "name": "What is IT staff augmentation?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "IT staff augmentation is a flexible outsourcing strategy where businesses hire external IT professionals temporarily to meet specific project needs or skill gaps without long-term commitments. This can be for short-term, long-term, or project-based engagements."
            }
        },
        {
            "@type": "Question",
            "name": "Which is more cost-effective: IT staff augmentation or in-house recruitment?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "IT staff augmentation is generally more cost-effective for short-term needs as it avoids benefits and training costs. In contrast, in-house recruitment involves higher upfront investment but can work out more cost-effectively over time due to lower turnover costs and deeper team integration."
            }
        },
        {
            "@type": "Question",
            "name": "What are the challenges of IT staff augmentation?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Challenges of staff augmentation include integrating external staff with the existing team, ensuring consistent communication, and managing data security. The temporary nature of augmented staff can affect team cohesion and continuity."
            }
        },
        {
            "@type": "Question",
            "name": "Which approach is better for long-term projects: IT staff augmentation or in-house hiring?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "In-house hiring is often better for long-term projects as it provides stability and deeper integration with the company's culture. Staff augmentation is more suited to short-term or specialized projects requiring immediate expertise."
            }
        }
    ]
}`;
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptArticle);
            document.head.appendChild(scriptFAQ);
        }
        if (window.location.pathname === "/blog/staff-augmentation-meaning") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/blog",
                    "name": "Blog"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/blog/staff-augmentation-meaning",
                    "name": "What is Staff Augmentation: Meaning, Definition, and Insights"
                }
            ]
        }`;
            var scriptArticle = document.createElement("script");
            scriptArticle.type = "application/ld+json";
            scriptArticle.innerHTML = `    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "What is Staff Augmentation: Meaning, Definition, and Insights",
      "image": "https://giraffesoftware.com/images/blog-article.jpg",
      "datePublished": "2024-08-15T15:00:00+02:00",
      "dateModified": "2024-08-15T15:00:00+02:00",
      "author": [{
          "@type": "Person",
          "name": "Prystupa Eugene",
          "url": "https://giraffesoftware.com/author"
        }]
    }`;
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
            "@type": "Question",
            "name": "What is IT staff augmentation, and how does it differ from traditional hiring?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": " IT staff augmentation involves bringing in external hires to work with the internal teams.  While traditional hiring involves lengthy recruitment processes that will have you searching far and wide for candidates you will have to vet on your own, staff augmentation means working with a firm that will help you quickly find the tech specialists you need from their pre-screened talent pool. "
            }
        },
        {
            "@type": "Question",
            "name": "What does staff augmentation mean for project management and delivery?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": " Staff augmentation allows companies to bring in the extra hands they need to complete a project and meet deadlines. Project managers can maintain a high level of control by managing external hires just like they manage internal staff."
            }
        },
        {
            "@type": "Question",
            "name": "What is meant by staff augmentation in terms of cost-effectiveness?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": " Companies can significantly reduce their overhead by eliminating expenses related to office space, hardware, recruitment, and turnover. Additionally, lower development rates in nearshore locations contribute to substantial savings, allowing companies to manage their budgets more effectively. This combination of factors makes staff augmentation an attractive option for businesses looking to optimize costs while accessing top talent."
            }
        },
        {
            "@type": "Question",
            "name": "How does staff augmentation align with flexible workforce solutions?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": " As the staff augmentation definition suggests, it's a recruitment solution that enables companies to hire specialists for specific periods, without the need for long-term contracts.  This approach allows businesses to easily scale their teams up or down as required, providing the flexibility to adapt to changing project demands and market conditions.  By leveraging staff augmentation, companies can quickly access the expertise they need, whether it's for short-term projects, seasonal workloads, or addressing skill gaps while maintaining control over their workforce and operating costs. "
            }
        }
    ]
}`;
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptArticle);
            document.head.appendChild(scriptFAQ);
        }
        if (window.location.pathname === "/blog/staff-augmentation-in-uk") {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/blog",
                    "name": "Blog"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/blog/staff-augmentation-in-uk",
                    "name": "Staff Augmentation in the UK: Achieve an Average of 38% Salary Savings with Nearshore
                                Contractors and Employees"
                }
            ]
        }`;
            var scriptArticle = document.createElement("script");
            scriptArticle.type = "application/ld+json";
            scriptArticle.innerHTML = `    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Staff Augmentation in the UK: Achieve an Average of 38% Salary Savings with Nearshore Contractors and Employees",
      "image": "https://giraffesoftware.com/images/blog-article.jpg",
      "datePublished": "2024-08-20T15:00:00+02:00",
      "dateModified": "2024-08-20T15:00:00+02:00",
      "author": [{
          "@type": "Person",
          "name": "Prystupa Eugene",
          "url": "https://giraffesoftware.com/author"
        }]
    }`;
            var scriptFAQ = document.createElement("script");
            scriptFAQ.type = "application/ld+json";
            scriptFAQ.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "FAQPage",
            "mainEntity": [{
            "@type": "Question",
            "name": "Why consider staff augmentation in the UK?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "If you're a technology company in the UK, staff augmentation offers benefits, including cost savings, fast access to diverse talent, upskilling opportunities for in-house teams, access to niche expertise, and the ability to replace engineers if needed quickly. It's a strategic approach to navigating economic uncertainties while staying efficient and competitive."
            }
        },
        {
            "@type": "Question",
            "name": "How does staff augmentation differ from outsourcing?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "Staff augmentation involves temporarily adding specific skills to your existing team, with the client maintaining full control over the work and integration. In contrast, outsourcing entails hiring an external company to handle entire projects or functions, giving them control over processes and outcomes."
            }
        },
        {
            "@type": "Question",
            "name": "What should I consider when choosing an outstaffing partner?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": "When choosing an outstaffing partner, consider factors such as cost efficiency, feedback from past clients, the company's portfolio and technology stack, and the level of partnership and trust. Look for vendors with competitive rates, positive reviews, experience with relevant technologies, and a track record of successful collaborations. Building a solid business relationship with your outstaffing partner is crucial for long-term success."
            }
        },
        {
            "@type": "Question",
            "name": "When should I consider augmenting my team with employees vs. contractors?",
            "acceptedAnswer": {
                "@type": "Answer",
                "text": " Augmenting your team with employees is suitable for long-term projects, sequential short-term projects, well-established workflows, and remote work experience. On the other hand, contractors are ideal for short-term projects, immediate start requirements, and when specialized skills are needed for specific phases."
            }
        }
    ]
}`;
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptArticle);
            document.head.appendChild(scriptFAQ);
        }
        if (
            window.location.pathname ===
            "/blog/how-to-choose-a-staff-augmentation-partner"
        ) {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/blog",
                    "name": "Blog"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/blog/how-to-choose-a-staff-augmentation-partne",
                    "name": "Proven and Unobvious Tips on How to Choose the Right Staff Augmentation Partner"
                }
            ]
        }`;
            var scriptArticle = document.createElement("script");
            scriptArticle.type = "application/ld+json";
            scriptArticle.innerHTML = `    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Proven and Unobvious Tips on How to Choose the Right Staff Augmentation Partner",
      "image": "https://giraffesoftware.com/images/blog-article.jpg",
      "datePublished": "2024-08-26T15:00:00+02:00",
      "dateModified": "2024-08-26T15:00:00+02:00",
      "author": [{
          "@type": "Person",
          "name": "Prystupa Eugene",
          "url": "https://giraffesoftware.com/author"
        }]
    }`;
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptArticle);
        }
        if (
            window.location.pathname ===
            "/blog/offshore-software-development-rates"
        ) {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/blog",
                    "name": "Blog"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/blog/offshore-software-development-rates",
                    "name": "Offshore Software Development Rates by Country: A Comprehensive Guide"
                }
            ]
        }`;
            var scriptArticle = document.createElement("script");
            scriptArticle.type = "application/ld+json";
            scriptArticle.innerHTML = `    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Offshore Software Development Rates by Country: A Comprehensive Guide",
      "image": "https://giraffesoftware.com/images/blog-article.jpg",
      "datePublished": "2024-08-29T15:00:00+02:00",
      "dateModified": "2024-08-29T15:00:00+02:00",
      "author": [{
          "@type": "Person",
          "name": "Prystupa Eugene",
          "url": "https://giraffesoftware.com/author"
        }]
    }`;
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptArticle);
        }
        if (
            window.location.pathname ===
            "/blog/hiring-dedicated-development-team"
        ) {
            var scriptList = document.createElement("script");
            scriptList.type = "application/ld+json";
            scriptList.innerHTML = `{
            "@context": "http://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": [{
                    "@type": "ListItem",
                    "position": 1,
                    "item": "https://giraffesoftware.com/",
                    "name": "Home"
                },
                {
                    "@type": "ListItem",
                    "position": 2,
                    "item": "https://giraffesoftware.com/blog",
                    "name": "Blog"
                },
                {
                    "@type": "ListItem",
                    "position": 3,
                    "item": "https://giraffesoftware.com/blog/hiring-dedicated-development-team",
                    "name": "Hiring Dedicated Development Team in 2024: The Ultimate Guide"
                }
            ]
        }`;
            var scriptArticle = document.createElement("script");
            scriptArticle.type = "application/ld+json";
            scriptArticle.innerHTML = `    {
      "@context": "https://schema.org",
      "@type": "Article",
      "headline": "Hiring Dedicated Development Team in 2024: The Ultimate Guide",
      "image": "https://giraffesoftware.com/images/blog-article.jpg",
      "datePublished": "2024-09-01T15:00:00+02:00",
      "dateModified": "2024-09-01T15:00:00+02:00",
      "author": [{
          "@type": "Person",
          "name": "Prystupa Eugene",
          "url": "https://giraffesoftware.com/author"
        }]
    }`;
            document.head.appendChild(scriptList);
            document.head.appendChild(scriptArticle);
        }
    },
    { passive: true }
);

const menuButton = document.getElementById("menuButton");
const closeButton = document.getElementById("closeButton");
const menuItems = document.getElementById("menuItems");

menuButton.addEventListener(
    "click",
    function () {
        menuItems.classList.add("menu-items");
        menuItems.style.display = "block";
    },
    { passive: true }
);
closeButton.addEventListener(
    "click",
    function () {
        menuItems.style.display = "none";
    },
    { passive: true }
);

const app = createApp({});
app.component("awards", Awards);
app.component("author", Author);
app.component("articles-pagination", ArticlesPagination);
app.component("subscribe", Subscribe);
app.component("charts", Charts);
app.component("about-us-carousel", AboutUsCarousel);
app.component("blog-tabs", BlogTabs);
// app.component("articles-pagination", ArticlesPagination);
app.component("dotted-map", DottedMap);
app.component("footer-section", FooterSection);
app.component("comments-article", CommentsArticle);
app.component("posts-and-services", PostsAndServices);
app.component("contact-form", ContactForm);
app.component("cookies", CookiesPopup);
app.component("clients", Clients);
app.component("case-studies", CaseStudies);
app.component("web-forms", WebForms);

app.config.globalProperties.$cookies = Cookies;
window.dataLayer = window.dataLayer || [];

window.pipedriveLeadboosterConfig = {
    base: "leadbooster-chat.pipedrive.com",
    companyId: 2144674,
    playbookUuid: "d18e3e71-4471-4ea0-ac94-6f68f2314f50",
    version: 2,
};

(function () {
    var w = window;
    if (w.LeadBooster) {
        console.warn("LeadBooster already exists");
    } else {
        w.LeadBooster = {
            q: [],
            on: function (n, h) {
                this.q.push({ t: "o", n: n, h: h });
            },
            trigger: function (n) {
                this.q.push({ t: "t", n: n });
            },
        };
    }
})();

let prevIsPoppupClosed;

setInterval(() => {
    const isPoppupClosed = Cookies.get("popup_closed") !== "false";

    if (isPoppupClosed === prevIsPoppupClosed) return;

    prevIsPoppupClosed = isPoppupClosed;
    document
        .getElementById("LeadboosterContainer")
        ?.style?.setProperty(
            "display",
            isPoppupClosed ? "block" : "none",
            "important"
        );
}, 75);

function gtag() {
    dataLayer.push(arguments);
}

gtag("js", new Date());
gtag("config", "UA-102504791-1");
app.config.globalProperties.$gtag = gtag;
window.initCookieAllowedScripts = function () {
    if (Cookies.get("cookies_accepted") === "true") {
        var scriptElement = document.createElement("script");

        scriptElement.src =
            "https://www.googletagmanager.com/gtag/js?id=UA-102504791-1";
        scriptElement.defer = true;
        scriptElement.nonce = "{{ csp_nonce() }}";

        document.head.appendChild(scriptElement);

        gtag("consent", "update", {
            ad_storage: "granted",
        });

        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-PKVHMHGJ");

        document.addEventListener("DOMContentLoaded", function () {
            document
                .getElementById("contactForm")
                .addEventListener("click", function () {
                    gtag("event", "form_submit", {
                        event_category: "Contact",
                        event_label: "Contact Form Submission",
                    });
                });
            document
                .querySelector(".contactButton")
                .addEventListener("click", function (event) {
                    gtag("event", "button_click", {
                        event_category: "Contact",
                        event_label: "Button Click to Contact Us Page",
                        hitCallback: function () {
                            window.location.href = "/contact-us";
                        },
                    });
                });
        });

        (function (h, o, t, j, a, r) {
            h.hj =
                h.hj ||
                function () {
                    (h.hj.q = h.hj.q || []).push(arguments);
                };
            h._hjSettings = { hjid: 3716470, hjsv: 6 };
            a = o.getElementsByTagName("head")[0];
            r = o.createElement("script");
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

        (function (l) {
            if (!l) {
                window.lintrk = function (a, b) {
                    window.lintrk.q.push([a, b]);
                };
                window.lintrk.q = [];
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })(
            window.lintrk,
            document,
            "script",
            "https://snap.licdn.com/li.lms-analytics/insight.min.js"
        );

        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
        );
        fbq("init", "905216314538974");
        fbq("track", "PageView");
    } else {
        gtag("consent", "update", {
            ad_storage: "denied",
        });
    }

    if (Cookies.get("cookies_marketing_accepted") === "true") {
        (function (l) {
            if (!l) {
                window.lintrk = function (a, b) {
                    window.lintrk.q.push([a, b]);
                };
                window.lintrk.q = [];
            }
            var s = document.getElementsByTagName("script")[0];
            var b = document.createElement("script");
            b.type = "text/javascript";
            b.async = true;
            b.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
            s.parentNode.insertBefore(b, s);
        })(
            window.lintrk,
            document,
            "script",
            "https://snap.licdn.com/li.lms-analytics/insight.min.js"
        );

        (function (f, b, e, v, n, t, s) {
            if (f.fbq) return;
            n = f.fbq = function () {
                n.callMethod
                    ? n.callMethod.apply(n, arguments)
                    : n.queue.push(arguments);
            };
            if (!f._fbq) f._fbq = n;
            n.push = n;
            n.loaded = !0;
            n.version = "2.0";
            n.queue = [];
            t = b.createElement(e);
            t.async = !0;
            t.src = v;
            s = b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t, s);
        })(
            window,
            document,
            "script",
            "https://connect.facebook.net/en_US/fbevents.js"
        );
        fbq("init", "905216314538974");
        fbq("track", "PageView");
    } else {
        gtag("consent", "update", {
            ad_storage: "denied",
        });
    }

    if (Cookies.get("cookies_analytics_accepted") === "true") {
        (function (h, o, t, j, a, r) {
            h.hj =
                h.hj ||
                function () {
                    (h.hj.q = h.hj.q || []).push(arguments);
                };
            h._hjSettings = { hjid: 3716470, hjsv: 6 };
            a = o.getElementsByTagName("head")[0];
            r = o.createElement("script");
            r.async = 1;
            r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv;
            a.appendChild(r);
        })(window, document, "https://static.hotjar.com/c/hotjar-", ".js?sv=");

        var scriptElement = document.createElement("script");

        scriptElement.src =
            "https://www.googletagmanager.com/gtag/js?id=UA-102504791-1";
        scriptElement.defer = true;
        scriptElement.nonce = "{{ csp_nonce() }}";

        document.head.appendChild(scriptElement);

        gtag("consent", "update", {
            ad_storage: "granted",
        });

        (function (w, d, s, l, i) {
            w[l] = w[l] || [];
            w[l].push({ "gtm.start": new Date().getTime(), event: "gtm.js" });
            var f = d.getElementsByTagName(s)[0],
                j = d.createElement(s),
                dl = l != "dataLayer" ? "&l=" + l : "";
            j.async = true;
            j.src = "https://www.googletagmanager.com/gtm.js?id=" + i + dl;
            f.parentNode.insertBefore(j, f);
        })(window, document, "script", "dataLayer", "GTM-PKVHMHGJ");

        document.addEventListener("DOMContentLoaded", function () {
            document
                .getElementById("contactForm")
                .addEventListener("click", function () {
                    gtag("event", "form_submit", {
                        event_category: "Contact",
                        event_label: "Contact Form Submission",
                    });
                });
            document
                .querySelector(".contactButton")
                .addEventListener("click", function (event) {
                    gtag("event", "button_click", {
                        event_category: "Contact",
                        event_label: "Button Click to Contact Us Page",
                        hitCallback: function () {
                            window.location.href = "/contact-us";
                        },
                    });
                });
        });
    } else {
        gtag("consent", "update", {
            ad_storage: "denied",
        });
    }
};
window.initCookieAllowedScripts();
app.mount("#content");
